import React from "react";
import { useLoading } from "@/contexts";
import "./Loading.css";

const Loading: React.FC = () => {
  const { isLoading } = useLoading();

  if (!isLoading) return null;

  return (
    <div className="loading-overlay">
      <div className="loading-spinner" />
    </div>
  );
};

export default Loading;
